// Presentation settings shared by hosted pages, the embed SDK and public APIs.
// Empty text inherits the existing flow/platform copy instead of replacing it.
export const CRM_SHARE_PAGE_FIELDS = [
  { key: 'heroEyebrow', label: '分享步骤标签', defaultText: '', maxLength: 80 },
  { key: 'heroTitle', label: '分享页标题', defaultText: '', maxLength: 160 },
  { key: 'heroDescription', label: '分享页说明', defaultText: '', maxLength: 800 },
  { key: 'progressReview', label: '进度：Review', defaultText: '', maxLength: 40 },
  { key: 'progressShare', label: '进度：Share', defaultText: '', maxLength: 40 },
  { key: 'progressAddress', label: '进度：Address', defaultText: '', maxLength: 40 },
  { key: 'platformChip', label: '平台信息', defaultText: '{{platform}}', maxLength: 120 },
  { key: 'orderChip', label: '订单信息', defaultText: 'Order {{orderId}}', maxLength: 160 },
  { key: 'ratingChip', label: '星级信息', defaultText: '{{rating}} Star Review', maxLength: 120 },
  { key: 'giftChip', label: '礼物信息', defaultText: '{{giftName}}', maxLength: 160 },
  { key: 'externalInstruction', label: '复制与跳转说明', defaultText: 'Copy the review text you already wrote, open the {{reviewTarget}} review page, and paste the same text there before continuing your {{continuation}}.', maxLength: 1200 },
  { key: 'commentLabel', label: '评论框名称', defaultText: 'Your comment', maxLength: 120 },
  { key: 'returnInstruction', label: '返回本页说明', defaultText: '', maxLength: 800 },
  { key: 'outboundButton', label: '复制并跳转按钮', defaultText: '', maxLength: 120 },
  { key: 'copyButton', label: '嵌入组件：复制按钮', defaultText: 'Copy Comment', maxLength: 120 },
  { key: 'copiedButton', label: '嵌入组件：已复制按钮文字', defaultText: 'Comment Copied', maxLength: 120 },
  { key: 'copyStatus', label: '复制操作状态提示', defaultText: '', maxLength: 400 },
  { key: 'noExternalInstruction', label: '无需跳转时的说明', defaultText: 'Your feedback is saved. This platform does not require an external review step for this {{processName}}.', maxLength: 800 },
  { key: 'screenshotInstruction', label: '截图上传说明', defaultText: 'Please upload the screenshot of your comment on the platform (Required)', maxLength: 400 },
  { key: 'screenshotHint', label: '未选择截图提示', defaultText: 'No file selected. Max {{maxSize}}.', maxLength: 240 },
  { key: 'screenshotUploading', label: '截图上传中提示', defaultText: 'Uploading screenshot...', maxLength: 120 },
  { key: 'backButton', label: '返回按钮文字', defaultText: 'Back', maxLength: 80, alwaysVisible: true },
  { key: 'continueButton', label: '继续到地址按钮文字', defaultText: 'Continue to Address', maxLength: 120, alwaysVisible: true },
]

const objectValue = (value) => value && typeof value === 'object' && !Array.isArray(value) ? value : {}

export const normalizeCrmSharePageSettings = (value) => {
  const raw = objectValue(value)
  return Object.fromEntries(CRM_SHARE_PAGE_FIELDS.map((field) => {
    const item = objectValue(raw[field.key])
    return [field.key, {
      text: typeof item.text === 'string' ? item.text.trim().slice(0, field.maxLength) : '',
      visible: field.alwaysVisible === true || item.visible !== false,
    }]
  }))
}

export const renderCrmSharePageText = (settings, key, values = {}, fallback = '') => {
  const field = CRM_SHARE_PAGE_FIELDS.find((item) => item.key === key)
  if (!field) return ''
  const configured = objectValue(objectValue(settings)[key])
  const template = (typeof configured.text === 'string' && configured.text.trim())
    || fallback || field.defaultText
  return String(template).replace(/\{\{\s*([a-zA-Z][a-zA-Z0-9]*)\s*\}\}/g,
    (_match, token) => Object.hasOwn(values, token) ? String(values[token] ?? '') : '')
}
